"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _DirectLink = _interopRequireDefault(require("../DirectLink"));

var _UserSelection = _interopRequireDefault(require("../UserSelection"));

var _MNet = _interopRequireDefault(require("../MNet"));

var _FourButton = _interopRequireDefault(require("../FourButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import GET_OFFER_BY_GROUP from '../utils/graphql/GET_OFFER_BY_GROUP';
// import ADD_SERVICE_LOG from '../utils/graphql/ADD_SERVICE_LOG';
// import CircularProgress from '@material-ui/core/CircularProgress';
// import { useQuery, useMutation } from '@apollo/react-hooks';
var OfferGroup = function OfferGroup(_ref) {
  var offer_group = _ref.offer_group,
      tracking = _ref.tracking,
      email = _ref.email,
      theme = _ref.theme;

  var routedOfferPage = function routedOfferPage() {
    switch (offer_group.offer_page) {
      case 'direct_link':
        return /*#__PURE__*/_react.default.createElement(_DirectLink.default, {
          isRedirection: tracking.isRedirect,
          isSubmission: tracking.isSubmission,
          url: offer_group['url'],
          jump: offer_group['jump'],
          tracking: tracking,
          email: email,
          kwd: offer_group['kwd'],
          offer: offer_group
        });

      case 'selection':
        return /*#__PURE__*/_react.default.createElement(_UserSelection.default, {
          theme: theme,
          offer: offer_group,
          tracking: tracking,
          email: email
        });

      case 'four_button':
        return /*#__PURE__*/_react.default.createElement(_FourButton.default, {
          offer: offer_group,
          tracking: tracking,
          email: email
        });

      case 'mNet':
        return /*#__PURE__*/_react.default.createElement(_MNet.default, {
          user: {
            sid: tracking['sid'],
            eid: tracking['eid'],
            hsid: tracking['hsid'],
            page: offer_group['url']
          },
          tracking: tracking,
          email: email
        });

      default:
        console.log('offer_page not recognized!!!!', offer_group);
        return /*#__PURE__*/_react.default.createElement("h1", null, "Oh no! an error! Please refresh the page...");
    }

    ;
  };

  return !!offer_group ? routedOfferPage() : null;
};

var _default = OfferGroup;
exports.default = _default;

//# sourceMappingURL=OfferGroup.jsx.map